import { useState, useEffect } from 'react';
import { Container, Card, Table, Spinner, Badge } from 'react-bootstrap';
import { getMyReferrals } from '../../api/userApi';
import { fmtIST } from '../../utils/dateFormat';

const Referrals = () => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyReferrals()
      .then((res) => setReferrals(res.data.referrals))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Container className="mt-5 text-center"><Spinner animation="border" /></Container>;

  return (
    <Container className="mt-4">
      <h4>My Direct Referrals <Badge bg="primary" className="ms-2">{referrals.length}</Badge></h4>
      <Card className="shadow-sm mt-3">
        <Table responsive hover className="mb-0">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>User Code</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {referrals.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center text-muted py-4">No referrals yet</td>
              </tr>
            ) : (
              referrals.map((r, i) => (
                <tr key={r._id}>
                  <td>{i + 1}</td>
                  <td>{r.name}</td>
                  <td>{r.email}</td>
                  <td>{r.mobile}</td>
                  <td><code>{r.userCode}</code></td>
                  <td>{fmtIST(r.createdAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card>
    </Container>
  );
};

export default Referrals;
